import React from 'react';
import { Trans } from '@lingui/macro';
import { FormattedMarkdown } from '@qover/react-intl';
import {
  GeographicalArea,
  TripType,
  FamilySituation,
  Variant,
} from '@qover-private/protos-web/qover/dojo/travel/v1/terms';

export const breadcrumbMessages = {
  needs: <Trans id="travel.needs.breadcrumb" />,
  quote: <Trans id="travel.quote.breadcrumb" />,
  options: <Trans id="travel.options.breadcrumb" />,
  insurers: <Trans id="travel.insurers.breadcrumb" />,
  finalization: <Trans id="travel.finalization.breadcrumb" />,
  summary: <Trans id="travel.summary.breadcrumb" />,
  payment: <Trans id="travel.payment.breadcrumb" />,
};

export const nextButtonMessages = {
  purchaseNow: <Trans id="travel.bottomNav.purchaseNow" />,
  continue: <Trans id="travel.bottomNav.continue" />,
  payNow: <Trans id="travel.bottomNav.payNow" />,
};

export const variantMessages = {
  standard: <FormattedMarkdown id="travel.variant.standard" />,
  premium: <FormattedMarkdown id="travel.variant.premium" />,
};

export const orderedVariantMessages = [
  variantMessages.standard,
  variantMessages.premium,
];

export const messagesPerVariant = {
  [TripType.TRIP_TYPE_SINGLE_TRIP]: {
    selectionLinkPlan: <Trans id="travel.selectionLinkSingle.plan" />,
    selectionLinkTripDuration: (tripDuration: number) => (
      <Trans
        id="travel.selectionLinkSingle.tripDuration"
        values={{ days: tripDuration }}
      />
    ),
    [GeographicalArea.GEOGRAPHICAL_AREA_EUROPE]: {
      planName: (tripDuration: number) => (
        <Trans
          id="travel.planNameSingleEurope"
          values={{ days: tripDuration }}
        />
      ),
      selectionLinkGeographicalArea: (
        <Trans id="travel.selectionLinkSingle.europe" />
      ),
    },
    [GeographicalArea.GEOGRAPHICAL_AREA_WORLD]: {
      planName: (tripDuration: number) => (
        <Trans
          id="travel.planNameSingleWorld"
          values={{ days: tripDuration }}
        />
      ),
      selectionLinkGeographicalArea: (
        <Trans id="travel.selectionLinkSingle.world" />
      ),
    },
  },
  [TripType.TRIP_TYPE_MULTI_TRIP]: {
    planName: (variant: Variant) =>
      variant === Variant.VARIANT_STANDARD ? (
        <Trans id="travel.planNameMulti" />
      ) : (
        <Trans id="travel.planNameMultiPlus" />
      ),
    selectionLinkPlan: <Trans id="travel.selectionLinkMulti.plan" />,
    selectionLinkTripDuration: () => (
      <Trans id="vel.selectionLinkMulti.tripDuration" />
    ),
  },
  [TripType.TRIP_TYPE_YEAR_TRIP]: {
    planName: () => <Trans id="travel.planNameYear" />,
    selectionLinkPlan: <Trans id="travel.selectionLinkYear.plan" />,
    selectionLinkTripDuration: () => (
      <Trans id="travel.selectionLinkYear.tripDuration" />
    ),
  },
  [FamilySituation.FAMILY_SITUATION_SINGLE]: {
    plan: <Trans id="travel.familySelectionSingle" />,
  },
  [FamilySituation.FAMILY_SITUATION_COUPLE]: {
    plan: <Trans id="travel.familySelectionCouple" />,
  },
  [FamilySituation.FAMILY_SITUATION_FAMILY]: {
    plan: <Trans id="travel.familySelectionFamily" />,
  },
};
